<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="subcontractor.subcontractor_name + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <template v-if="is_subcontractor">
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                            <router-link to="/">
                                <i class="fa fa-id-badge"></i> Dashboard
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                            <router-link to="/subcontractors/view">
                                {{ subcontractor.subcontractor_name }}
                            </router-link>
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                            <router-link :to="`/subcontractors`">
                                <i class="fa fa-id-badge"></i> Subcontractors
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                            <router-link :to="`/subcontractors/view/${subcontractor.subcontractor_id}`">
                                {{ subcontractor.subcontractor_name }}
                            </router-link>
                        </li>
                    </template>

                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        <i class="fa fa-check-square"></i> Pre-Qualification
                        <span v-if="is_subcontractor" :class="`badge badge-${subcontractor.status_color}`">{{ subcontractor.status_name }}</span>
                    </li>
                </ol>
            </h4>

            <div class="row mb-3">
                <div class="col-xl-8 col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            Pre-Qualification: <strong>{{ subcontractor.subcontractor_name }}</strong>

                            <div class="float-sm-right mt-sm-0 mt-2">
                                <router-link :to="`/subcontractors/print/${subcontractor.subcontractor_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-print"></i> Print
                                </router-link>

                                <!-- <router-link v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')" :to="`/subcontractors/edit/${subcontractor.subcontractor_id}`" class="btn btn-sm btn-secondary">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link> -->

                                <router-link
                                    v-if="!is_subcontractor && this.$root.hasPermission(['subcontractors.manage', 'subcontractors.edit'])"
                                    :to="`/subcontractors/qualification/edit/${subcontractor.subcontractor_id}`"
                                    class="btn btn-sm btn-light"
                                    title="Edit Pre-Qualification">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>

                                <router-link v-if="is_subcontractor" to="/subcontractors/qualification/edit" class="btn btn-sm btn-light">
                                    <i class="fa fa-check"></i> Edit Pre-Qualification
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="row mb-3">
                                        <div class="col text-muted text-md-right">Status:</div>
                                        <div class="col-md-8">
                                            <h5 class="mb-0" style="display: inline-block">
                                                <span :title="subcontractor.status_desc" :class="`badge badge-${subcontractor.status_color}`">{{ subcontractor.status_name }}</span>
                                                    <template v-if="!is_subcontractor && this.$root.hasPermission(['subcontractors.manage'])">
                                                        <b-button size="xs" variant="link" style="font-size: 0.75rem !important;" v-on:click="approvalAction()" title="Approved, Reject, or send status back to In Progress">
                                                            <i class="fa fa-edit"></i> Status
                                                        </b-button>
                                                    </template>
                                            </h5>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Subcontractor Name:</div>
                                        <div class="col-md-8">{{ subcontractor.subcontractor_name }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Created:</div>
                                        <div class="col-md-8">{{ subcontractor.created_at | moment('timezone', this.$store.state.user.timezone, "MM/DD/YYYY") }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Last Updated:</div>
                                        <div class="col-md-8">{{ subcontractor.updated_at | moment("MM/DD/YYYY") }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Approved Until:</div>
                                        <div class="col-md-8">
                                            <template v-if="subcontractor.valid_until">{{ subcontractor.valid_until | moment("MM/DD/YYYY") }}</template>
                                            <b-button size="xs" variant="link" v-on:click="editApprovedUntil()" v-if="this.$root.hasPermission('subcontractors.manage') && (subcontractor.status_id == 3 || subcontractor.status_id == 5)" title="Edit Approved Until">
                                                <i class="fa fa-edit"></i>
                                            </b-button>

                                            <b-modal
                                                v-model="showApprovedEditModal"
                                                title="Subcontractor Approved Until"
                                                size="lg"
                                                ok-title="Update Approved Until"
                                                ok-variant="success"
                                                no-fade
                                                @ok="updateApprovedUntil"
                                                :ok-disabled="updatingApproved"
                                                ref="subApprovedUntilEditModal"
                                                :no-close-on-backdrop="true"
                                                scrollable>

                                                <div style="min-height: 300px;">
                                                    <div v-bind:class="{ 'form-group row': true, 'has-error': errors.valid_until }">
                                                        <label class="col-md-3 col-12 col-form-label text-sm-right">
                                                            Approved Until: <i class="fa fa-asterisk text-danger"></i>
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <date-picker
                                                                :value="readDate(subcontractor.valid_until)"
                                                                @input="subcontractor.valid_until = writeDate($event)"
                                                                :config="{format: 'MM/DD/YYYY', useCurrent: false}"
                                                                :class="{ 'is-invalid': errors.valid_until }"
                                                                placeholder="Approved Until"></date-picker>

                                                            <span v-if="errors.valid_until" class="text-danger">
                                                                <span v-for="error in errors.valid_until">{{ error }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-modal>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">OSHA Exempt: <i class="fa fa-question-circle" title="This subcontractor is exempt from being required to provide OSHA data"></i></div>
                                        <div class="col-md-8">
                                            <label v-if="subcontractor.is_osha_exempt === 1" class="badge badge-sm badge-warning">Yes</label>
                                            <label v-else class="badge badge-sm badge-default">No</label>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="!is_subcontractor && mostRecentStatusComment">
                                        <div class="col text-muted text-md-right">
                                            <label class="badge badge-warning">Status Comment:</label>
                                        </div>
                                        <div class="col-md-8">
                                            <div>
                                                <b-button size="xs" variant="link" v-on:click="editStatusComment()" title="Edit Status Comment" v-if="this.$root.hasPermission('subcontractors.manage')">
                                                    <i class="fa fa-edit"></i>
                                                </b-button>
                                                {{ mostRecentStatusComment.comment_details }}
                                            </div>

                                            <b-modal
                                                v-model="showStatusCommentEditModal"
                                                title="Status Comment"
                                                size="lg"
                                                ok-title="Update Status Comment"
                                                ok-variant="success"
                                                no-fade
                                                @ok="updateStatusComment"
                                                :ok-disabled="updatingStatusComment"
                                                ref="subbStatusCommentEditModal"
                                                :no-close-on-backdrop="true"
                                                scrollable>

                                                <div style="min-height: 300px;">
                                                    <div v-bind:class="{ 'form-group row': true, 'has-error': errors.comment_details }">
                                                        <label class="col-md-3 col-12 col-form-label text-sm-right">
                                                            Comments: <i class="fa fa-asterisk text-danger"></i>
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <b-form-textarea v-model="mostRecentStatusComment.comment_details" :class="{'is-invalid': errors.comment_details }" :rows="4" :max-row="8" placeholder="Enter Status Comment"></b-form-textarea>

                                                            <span v-if="errors.comment_details" class="text-danger">
                                                                <span v-for="error in errors.comment_details">{{ error }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3" v-if="false">
                        <div class="card-header">
                            <strong><i class="fa fa-unlock"></i> Public Access <i class="fa fa-question-circle" title="Enable Public Access to Create a Link Subcontractors can use to view and edit their qualification form"></i></strong>

                            <div class="float-sm-right mt-sm-0 mt-2">
                                <router-link :to="`/subcontractors/public-access/${subcontractor.subcontractor_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit Public Access
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Enable Public Access:</div>
                                        <div class="col-md-8">{{ subcontractor.enable_public_access === 1 ? 'Yes' : 'No' }}</div>
                                    </div>

                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Public Link Expiration:</div>
                                        <div class="col-md-8">
                                            <span v-if="subcontractor.public_access_expires_at">{{ subcontractor.public_access_expires_at | moment("MM/DD/YYYY") }}</span>
                                        </div>
                                    </div>

                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted text-md-right">Public Access Link:</div>
                                        <div class="col-md-8">
                                            <a :href="`${publicUrl}`" target="_blank" v-if="subcontractor.enable_public_access == 1">{{ publicUrl }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong><i class="fa fa-group"></i> Users</strong>
                            <div class="pull-right">
                                <router-link v-if="!is_subcontractor && this.$root.hasPermission(['subcontractors.manage'])" :to="`/users/create?subcontractor_id=${subcontractor.subcontractor_id}`" class="btn btn-sm btn-primary">
                                    <i class="fa fa-plus-circle"></i> Add
                                </router-link>
                            </div>
                        </div>
                        <div class="list-group list-group-flush">
                            <template v-if="users.length > 0">
                                <li class="list-group-item" v-for="user in users">
                                    <div class="media align-items-center">
                                        <div class="media-body">
                                            <router-link :to="`/users/view/${user.UserId}`" class="text-dark">{{ user.FirstName }} {{ user.LastName }}</router-link> <a :href="`mailto:${user.email}`" title="Email User">{{ user.email }}</a><br>
                                            <div class="text-muted">Last Login: {{ user.LastLoginDate | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</div>
                                            <span v-if="user.sub_permissions" class="badge badge-warning">{{ user.sub_permissions }}</span>
                                        </div>
                                    </div>
                                </li>
                            </template>
                            <template v-else>
                                <li class="list-group-item">-- No users --</li>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!is_subcontractor" class="mb-4" style="margin-top: 60px;">
                <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                    <b-nav-item :active="curTab === 'comments'" @click="curTab = 'comments'">
                        <i class="fa fa-comments"></i> Comments ({{ totalComments }})
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'files'" @click="curTab = 'files'">
                        <i class="fa fa-files-o"></i> Files ({{ files_array.length }})
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'approvals'" @click="curTab = 'approvals'" v-if="this.$root.hasPermission('subcontractors.view.approvals')">
                        <i class="fa fa-address-book-o"></i> Client Approvals ({{ totalClientApprovals }})
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'status_history'" @click="curTab = 'status_history'">
                        <i class="fa fa-sitemap"></i> Status History ({{ statusHistory.length }})
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'history'" @click="curTab = 'history'">
                        <i class="fa fa-clock-o"></i> All History ({{ totalHistory }})
                    </b-nav-item>
                    <b-nav-item :active="curTab === 'osha'" @click="curTab = 'osha'">
                        <i class="fa fa-hard-hat"></i> OSHA Data
                    </b-nav-item>
                </ul>

                <div class="mb-2 mb-lg-0 d-lg-none d-block">
                    <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                        <b-dropdown-item :active="curTab === 'comments'" @click="curTab = 'comments'">
                            <i class="fa fa-comments"></i> Comments ({{ totalComments }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'files'" @click="curTab = 'files'">
                            <i class="fa fa-files-o"></i> Files ({{ files_array.length }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'approvals'" @click="curTab = 'approvals'" v-if="this.$root.hasPermission('subcontractors.view.approvals')">
                            <i class="fa fa-address-book-o"></i> Client Approvals ({{ totalClientApprovals }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'status_history'" @click="curTab = 'status_history'">
                            <i class="fa fa-sitemap"></i> Status History ({{ statusHistory.length }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'history'" @click="curTab = 'history'">
                            <i class="fa fa-clock-o"></i> History ({{ totalHistory }})
                        </b-dropdown-item>
                        <b-dropdown-item :active="curTab === 'osha'" @click="curTab = 'osha'">
                            <i class="fa fa-hard-hat"></i> OSHA Data
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="mt-4">
                    <div class="card" v-show="curTab === 'comments'">
                        <div class="card-body">
                            <comment-list
                                :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                                ref="commentList"
                                :assetId="subcontractor.subcontractor_id"
                                assetType="SubPreQual"
                                @commentListCount="(total) => { this.totalComments = total; }"></comment-list>
                        </div>
                    </div>
                    <div class="card" v-show="curTab === 'files'">
                        <div class="card-body">
                            <file-table :files="files_array" :columns="file_columns" :options="file_options" />
                        </div>
                    </div>
                    <div class="card" v-show="curTab === 'approvals'" v-if="this.$root.hasPermission('subcontractors.view.approvals')">
                        <div class="card-body">
                            <div class="alert alert-danger" v-if="approvals_out_of_date">
                                <strong>Warning:</strong> These Client Approvals may be out of date. The related qualification metric data was last updated on:
                                <strong>{{ subcontractor.approval_data_changed_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</strong>
                            </div>
                            <client-subcontractor-approvals
                                assetType="SubPreQual"
                                :assetId="subcontractor.subcontractor_id"
                                :columns="columns"
                                @firstClientSubApproval="doApprovalsNeedRecalculating"
                                @totalClientApprovals="(total) => { this.totalClientApprovals = total; }"></client-subcontractor-approvals>
                        </div>
                    </div>
                    <div class="card" v-show="curTab === 'status_history'">
                        <div class="card-body">
                            <status-history :histories="filteredOrderedHistory()" />
                        </div>
                    </div>
                    <div class="card" v-show="curTab === 'history'">
                        <div class="card-body">
                            <history-list
                                recordType="SubPreQual"
                                :recordId="subcontractor.subcontractor_id"
                                @historyCount="(total) => { this.totalHistory = total; }" />
                        </div>
                    </div>
                    <div class="card" v-show="curTab === 'osha'">
                        <div class="card-body">
                            <osha-sub-list :subcontractor_id="subcontractor.subcontractor_id" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Section 1 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 1:</span> General Information</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(1).status_color}`">{{ sectionStatus(1).status_name != null ? sectionStatus(1).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(1)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(1).status_color}`">{{ sectionStatus(1).status_name != null ? sectionStatus(1).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(1)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 1
                        </span>
                        <span class="d-sm-none d-block">
                            S1
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-12">
                                <div class="row mb-2" v-if="settingIsOn(1, 'pre_qual_3rd_question_show_hide')">
                                    <div class="mb-0 col-lg-2 col-md-3 col-12 text-md-right text-muted">Pre-Qualified via 3rd party?:</div>
                                    <div class="col-md-9 col-12">
                                        <span v-if="subcontractor.prequalified_3rd_party == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.prequalified_3rd_party == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-2" v-if="settingIsOn(1, 'pre_qual_3rd_file_show_hide')">
                                    <div class="mb-0 col-lg-2 col-md-3 col-12 text-md-right text-muted">3rd Party Certification:</div>
                                    <div class="col-md-9 col-12">
                                        <file-list :basicView="true" :files="subcontractor.prequalified_file ? [subcontractor.prequalified_file] : []" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="custom_field_sections[1] && custom_field_sections[1].fields.length > 0">
                            <custom-field-view :section="custom_field_sections[1] ? custom_field_sections[1] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>

                        <hr/>
                        <bid-list :subcontractorId="subcontractor.subcontractor_id" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[1] ? this.sectionComments[1] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[1] ? this.sectionComments[1] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList1"
                            :sectionNumber="1"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[1] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[1] ? this.files[1].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[1] ? this.files[1].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(1)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History ({{ this.statusHistoryBySection[1] ? this.statusHistoryBySection[1].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i> ({{ this.statusHistoryBySection[1] ? this.statusHistoryBySection[1].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(1)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 2 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 2:</span> Company Information</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(2).status_color}`">{{ sectionStatus(2).status_name != null ? sectionStatus(2).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(2)" title="Approved, Reject, or send status back to In Progress">
                                <i class="fa fa-edit"></i> Status
                            </b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(2).status_color}`">{{ sectionStatus(2).status_name != null ? sectionStatus(2).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(2)" title="Approved, Reject, or send status back to In Progress">
                                <i class="fa fa-edit"></i> Status
                            </b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 2
                        </span>
                        <span class="d-sm-none d-block">
                            S2
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Name:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.subcontractor_name }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Address:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.address }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">City:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.city }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">State:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.state }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Zip:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.zip }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Phone:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.phone }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Fax:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.fax }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Website:</label>
                                    <div class="col-md-8">
                                        <a :href="(subcontractor.website.indexOf('http://') === -1 && subcontractor.website.indexOf('https://') === -1) ? `http://${subcontractor.website}` : subcontractor.website" v-if="subcontractor.website" target="_blank">{{ subcontractor.website }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Contact Name:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.company_contact_name }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Contact Phone:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.company_contact_phone }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Contact Email:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.company_contact_email }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Office Type:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.office_name }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Other Names:</label>
                                    <div class="col-md-8">
                                        <span v-if="subcontractor.has_other_names == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_other_names == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Other Operating Names:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.other_names }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Business Start Date:</label>
                                    <div class="col-md-8">
                                        <template v-if="subcontractor.business_start_date">{{ subcontractor.business_start_date | moment("MM/YYYY") }}</template>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Business Age:</label>
                                    <div class="col-md-8">
                                        {{ subcontractorAge }} years
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Parent Company:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.parent_company }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr/>

                        <sub-designation-list :subcontractorId="subcontractor.subcontractor_id" />
                        <hr/>

                        <sub-license-list  :subcontractorId="subcontractor.subcontractor_id" />

                        <template v-if="custom_field_sections[2] && custom_field_sections[2].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[2] ? custom_field_sections[2] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[2] ? this.sectionComments[2] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[2] ? this.sectionComments[2] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList2"
                            :sectionNumber="2"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[2] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[2] ? this.files[2].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[2] ? this.files[2].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(2)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[2] ? this.statusHistoryBySection[2].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[2] ? this.statusHistoryBySection[2].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(2)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 3 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 3:</span> Work Performed</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(3).status_color}`">{{ sectionStatus(3).status_name != null ? sectionStatus(3).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(3)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(3).status_color}`">{{ sectionStatus(3).status_name != null ? sectionStatus(3).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(3)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 3
                        </span>
                        <span class="d-sm-none d-block">
                            S3
                        </span>
                    </template>
                    <b-card-body>
                        <div class="">
                            <div class="">
                                <label class="text-muted">Trades ({{ trades.length }}):</label>
                                <ul>
                                    <li v-for="trade in trades">{{ trade }}</li>
                                    <li v-if="subcontractor.other_trades"><b>Other:</b> {{ subcontractor.other_trades }}</li>
                                </ul>
                            </div>
                            <div class="" v-if="settingIsOn(3, 'areas_of_work_show_hide')">
                                <label class="text-muted">Geographic Areas Willing to Work ({{ areas.length }}):</label>
                                <ul>
                                    <li v-for="area in areas">{{ area }}</li>
                                    <li v-if="subcontractor.other_areas"><b>Other:</b> {{ subcontractor.other_areas }}</li>
                                </ul>
                            </div>
                            <div class="">
                                <label class="text-muted">State Registrations ({{ sub_registrations.length }}):</label>

                                <table class="table table-bordered table-condensed">
                                    <thead class="bg-light">
                                        <tr>
                                            <th style="min-width: 150px;">State</th>
                                            <th>Registration# or Note</th>
                                            <th>Copy of Registration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(reg, i) in sub_registrations">
                                            <td>
                                                {{ reg.state_name }}
                                            </td>
                                            <td>
                                                {{ reg.registration_notes }}
                                            </td>
                                            <td>
                                                <a :href="`/files/view/${reg.registration_file_id}`" v-if="reg.registration_file_id" target="_blank">{{ reg.file_name }}</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <template v-if="custom_field_sections[3] && custom_field_sections[3].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[3] ? custom_field_sections[3] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[3] ? this.sectionComments[3] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[3] ? this.sectionComments[3] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList3"
                            :sectionNumber="3"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[3] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[3] ? this.files[3].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[3] ? this.files[3].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(3)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[3] ? this.statusHistoryBySection[3].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[3] ? this.statusHistoryBySection[3].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(3)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 4 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 4:</span> Financial Information</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(4).status_color}`">{{ sectionStatus(4).status_name != null ? sectionStatus(4).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(4)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(4).status_color}`">{{ sectionStatus(4).status_name != null ? sectionStatus(4).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(4)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 4
                        </span>
                        <span class="d-sm-none d-block">
                            S4
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Structure:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.comp_structure_name }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Dun &amp; Bradstreet Number:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.db_number }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Name of Your Company's Bank:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.bank_name }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Bank Address:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.bank_address }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Bank Contact Name &amp; Phone:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.bank_contact }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Federal ID# or SS#:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.company_id_num }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">IRS Form W9:</label>
                                    <div class="col-md-8">
                                        <file-list :basicView="true" :files="subcontractor.irs_w9 ? [subcontractor.irs_w9] : []" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="custom_field_sections[4] && custom_field_sections[4].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[4] ? custom_field_sections[4] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[4] ? this.sectionComments[4] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[4] ? this.sectionComments[4] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList4"
                            :sectionNumber="4"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[4] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[4] ? this.files[4].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[4] ? this.files[4].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(4)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[4] ? this.statusHistoryBySection[4].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[4] ? this.statusHistoryBySection[4].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(4)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 5 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 5:</span> Health, Safety & Environmental</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(5).status_color}`">{{ sectionStatus(5).status_name != null ? sectionStatus(5).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(5)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(5).status_color}`">{{ sectionStatus(5).status_name != null ? sectionStatus(5).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(5)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 5
                        </span>
                        <span class="d-sm-none d-block">
                            S5
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Current Number of Employees:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.company_size }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Safety Representative Name:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.safety_rep_name }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">HSE Credentials:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.hse_credentials }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Years of Experience:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.years_of_experience }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Safety Representative Phone:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.safety_rep_phone }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Company Safety Representative Email:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.safety_rep_email }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Has Written Safety &amp; Health Program:</label>
                                    <div class="col-md-6">
                                        <span v-if="subcontractor.has_written_program == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_written_program == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">HSE Program File:</label>
                                    <div class="col-md-6">
                                        <file-list :basicView="true" :files="subcontractor.program_file ? [subcontractor.program_file] : []" />
                                    </div>
                                </div>
                                <!-- Empty row to keep spacing consistent -->
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">&nbsp;</label>
                                    <div class="col-md-6">
                                        &nbsp;
                                    </div>
                                </div>
                                <div class="mb-1">
                                    <label class="text-muted">Field Craft Personnel Training:</label><br/>
                                    <ul>
                                        <li v-for="training in fieldTrainings">{{ training }}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Safety Orientation:</label>
                                    <div class="col-md-6">
                                        <span v-if="subcontractor.has_safety_orientation == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_safety_orientation == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Competent Person Training:</label>
                                    <div class="col-md-6">
                                        <span v-if="subcontractor.has_person_training == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_person_training == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Employee Safety Meetings:</label>
                                    <div class="col-md-6">
                                        <span v-if="subcontractor.has_safety_meetings == 1" class="badge badge-success">
                                            Yes - Frequency: {{ subcontractor.meeting_frequency }}
                                        </span>
                                        <span v-else-if="subcontractor.has_safety_meetings == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Title of Safety Meeting Host:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.meeting_host_title }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Substance Abuse Policy:</label>
                                    <div class="col-md-6">
                                        <span v-if="subcontractor.substance_abuse_policy == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.substance_abuse_policy == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">EMR Letter:</label>
                                    <div class="col-md-6">
                                        <file-list :basicView="true" :files="subcontractor.emr_file ? [subcontractor.emr_file] : []" />
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Safety Differentiators:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.safety_differentiators }}
                                    </div>
                                </div>
                                <div class="mb-1">
                                    <label class="text-muted">Testing Frequency:</label>
                                    <ul>
                                        <li v-for="testing in testings">{{ testing }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr/>

                        <sub-osha-years-list :subcontractorId="subcontractor.subcontractor_id" />
                        <hr/>

                        <osha-citation-list :subcontractorId="subcontractor.subcontractor_id" />

                        <template v-if="custom_field_sections[5] && custom_field_sections[5].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[5] ? custom_field_sections[5] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[5] ? this.sectionComments[5] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[5] ? this.sectionComments[5] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList5"
                            :sectionNumber="5"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[5] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[5] ? this.files[5].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[5] ? this.files[5].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(5)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[5] ? this.statusHistoryBySection[5].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[5] ? this.statusHistoryBySection[5].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(5)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 6 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 6:</span> Insurance Information</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(6).status_color}`">{{ sectionStatus(6).status_name != null ? sectionStatus(6).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(6)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(6).status_color}`">{{ sectionStatus(6).status_name != null ? sectionStatus(6).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(6)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 6
                        </span>
                        <span class="d-sm-none d-block">
                            S6
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Certificate of Insurance:</label>
                                    <div class="col-md-8">
                                        <file-list :basicView="true" :files="subcontractor.insurance_file ? [subcontractor.insurance_file] : []" />
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Insurance Company &amp; Info:</label>
                                    <div class="col-md-8">
                                        {{ subcontractor.insurance_info }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="custom_field_sections[6] && custom_field_sections[6].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[6] ? custom_field_sections[6] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[6] ? this.sectionComments[6] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[6] ? this.sectionComments[6] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList6"
                            :sectionNumber="6"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[6] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[6] ? this.files[6].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[6] ? this.files[6].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(6)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[6] ? this.statusHistoryBySection[6].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[6] ? this.statusHistoryBySection[6].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(6)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 7 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 7:</span> Bonding Information</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(7).status_color}`">{{ sectionStatus(7).status_name != null ? sectionStatus(7).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(7)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(7).status_color}`">{{ sectionStatus(7).status_name != null ? sectionStatus(7).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(7)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 7
                        </span>
                        <span class="d-sm-none d-block">
                            S7
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Bonding Company:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.bonding_company }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Copy of Bonding Letter:</label>
                                    <div class="col-md-6">
                                        <file-list :basicView="true" :files="subcontractor.bonding_file ? [subcontractor.bonding_file] : []" />
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Bonding Agent &amp; Firm:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.bonding_agent_firm }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Phone:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.bonding_phone }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Previous Bonding Companies:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.bonding_previous_companies }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Max. Overall Bonding Capacity:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.bonding_max_capacity }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Max. Bonding Capacity Per Contract:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.bonding_max_contract }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Bonding Company Start Date:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.bonding_start_date }}
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Years With Bonding Company:</label>
                                    <div class="col-md-6">
                                        {{ bondingAge || 0 }} Years
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="custom_field_sections[7] && custom_field_sections[7].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[7] ? custom_field_sections[7] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[7] ? this.sectionComments[7] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[7] ? this.sectionComments[7] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList7"
                            :sectionNumber="7"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[7] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[7] ? this.files[7].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[7] ? this.files[7].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(7)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[7] ? this.statusHistoryBySection[7].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[7] ? this.statusHistoryBySection[7].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(7)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 8 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 8:</span> Past Performance</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(8).status_color}`">{{ sectionStatus(8).status_name != null ? sectionStatus(8).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(8)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(8).status_color}`">{{ sectionStatus(8).status_name != null ? sectionStatus(8).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(8)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 8
                        </span>
                        <span class="d-sm-none d-block">
                            S8
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-lg-5">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">EComplaint Filed by Licensing/Regulatory Agency:</label>
                                    <div class="col-sm-2">
                                        <span v-if="subcontractor.has_official_complaint == 1" class="badge badge-danger">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_official_complaint == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Contract Terminated for Cause:</label>
                                    <div class="col-sm-2">
                                        <span v-if="subcontractor.has_terminated_contract == 1" class="badge badge-danger">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_terminated_contract == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Failed to Complete Work:</label>
                                    <div class="col-sm-2">
                                        <span v-if="subcontractor.has_failed_work == 1" class="badge badge-danger">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_failed_work == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Judgments or Claims Pending:</label>
                                    <div class="col-sm-2">
                                        <span v-if="subcontractor.has_pending_claims == 1" class="badge badge-danger">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_pending_claims == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Involved in Arbitration Proceedings:</label>
                                    <div class="col-sm-2">
                                        <span v-if="subcontractor.has_arbitration == 1" class="badge badge-danger">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_arbitration == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7">
                                <label class="text-muted">Explain All "Yes" Responses:</label><br>
                                {{ subcontractor.past_performance }}
                            </div>
                        </div>

                        <template v-if="custom_field_sections[8] && custom_field_sections[8].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[8] ? custom_field_sections[8] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[8] ? this.sectionComments[8] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[8] ? this.sectionComments[8] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList8"
                            :sectionNumber="8"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[8] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[8] ? this.files[8].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[8] ? this.files[8].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(8)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[8] ? this.statusHistoryBySection[8].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[8] ? this.statusHistoryBySection[8].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(8)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 9 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 9:</span> References</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(9).status_color}`">{{ sectionStatus(9).status_name != null ? sectionStatus(9).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(9)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(9).status_color}`">{{ sectionStatus(9).status_name != null ? sectionStatus(9).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(9)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 9
                        </span>
                        <span class="d-sm-none d-block">
                            S9
                        </span>
                    </template>
                    <b-card-body>
                        <references-list :subcontractorId="subcontractor.subcontractor_id"></references-list>

                        <hr/>

                        <div class="row mb-1">
                            <label class="col-md-3 text-muted text-right">Has Your Company Performed Past Work:</label>
                            <div class="col-md-8">
                                {{ subcontractor.has_previous_projects == 1 ? 'Yes' : 'No' }}
                            </div>
                        </div>
                        <div class="row mb-1">
                            <label class="col-md-3 text-muted text-right">Past Projects:</label>
                            <div class="col-md-8">
                                {{ subcontractor.other_projects }}
                            </div>
                        </div>

                        <template v-if="custom_field_sections[9] && custom_field_sections[9].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[9] ? custom_field_sections[9] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[9] ? this.sectionComments[9] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[9] ? this.sectionComments[9] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList9"
                            :sectionNumber="9"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[9] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[9] ? this.files[9].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[9] ? this.files[9].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(9)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[9] ? this.statusHistoryBySection[9].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[9] ? this.statusHistoryBySection[9].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(9)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Section 10 -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0"><span class="text-muted">Section 10:</span> EEO & Eligibility To Work</h5>
                    <div class="d-sm-inline-block d-none">
                        <span :class="`badge badge-${sectionStatus(10).status_color}`">{{ sectionStatus(10).status_name != null ? sectionStatus(10).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(10)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
                <div class="col-sm-4 col-xs-12">
                    <div class="d-sm-none d-block">
                        <span :class="`badge badge-${sectionStatus(10).status_color}`">{{ sectionStatus(10).status_name != null ? sectionStatus(10).status_name : '' }}</span>
                        <template v-if="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')">
                            <b-button v-if="subcontractor.status_id != 1" size="xs" variant="link" v-on:click="approvalActionSection(10)" title="Approved, Reject, or send status back to In Progress"><i class="fa fa-edit"></i> Status</b-button>
                        </template>
                    </div>
                </div>
            </div>
            <b-tabs class="nav-tabs-top mt-0 mb-3">
                <b-tab no-body active>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            Section 10
                        </span>
                        <span class="d-sm-none d-block">
                            S10
                        </span>
                    </template>
                    <b-card-body>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">(1)(a) Written EEO Policy:</label>
                                    <div class="col-md-4">
                                        <span v-if="subcontractor.has_eeo_policy == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_eeo_policy == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">(1)(b) Anti-Harassment Policy:</label>
                                    <div class="col-md-4">
                                        <span v-if="subcontractor.has_harassment_policy == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_harassment_policy == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">(1)(c) Employee Complaint Procedure:</label>
                                    <div class="col-md-4">
                                        <span v-if="subcontractor.has_complaint_procedure == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_complaint_procedure == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">(1)(d) Designated EEO Officer:</label>
                                    <div class="col-md-4">
                                        <span v-if="subcontractor.has_eeo_officer == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_eeo_officer == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">EEO Officer Credentials:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.eeo_officer_credentials }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">Copy of EEO Policies:</label>
                                    <div class="col-md-6">
                                        <file-list :basicView="true" :files="subcontractor.eeo_file ? [subcontractor.eeo_file] : []" />
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">(2)(a) Verify Employee Eligibility:</label>
                                    <div class="col-md-6">
                                        <span v-if="subcontractor.has_verify_employees == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_verify_employees == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">(2)(b) Maintain of Compliance Records:</label>
                                    <div class="col-md-6">
                                        <span v-if="subcontractor.has_compliance_records == 1" class="badge badge-success">
                                            Yes
                                        </span>
                                        <span v-else-if="subcontractor.has_compliance_records == 0" class="badge badge-default">
                                            No
                                        </span>
                                    </div>
                                </div>
                                <div class="row mb-1">
                                    <label class="col text-muted text-right">(2)(c) E-Verify ID Number:</label>
                                    <div class="col-md-6">
                                        {{ subcontractor.e_verify_id }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="custom_field_sections[10] && custom_field_sections[10].fields.length > 0">
                            <hr />

                            <custom-field-view :section="custom_field_sections[10] ? custom_field_sections[10] : {}" labelSize="col-lg-2 col-md-3 col-12 text-md-right text-muted" />
                        </template>
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-comments"></i> Comments ({{ this.sectionComments[10] ? this.sectionComments[10] : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-comments"></i> ({{ this.sectionComments[10] ? this.sectionComments[10] : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <comment-list
                            :allowNewComments="!is_subcontractor && this.$root.hasPermission('subcontractors.manage')"
                            ref="commentList10"
                            :sectionNumber="10"
                            :assetId="subcontractor.subcontractor_id"
                            assetType="SubPreQual"
                            @commentListCount="(total) => { this.sectionComments[10] = total; }" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-files-o"></i> Files ({{ this.files[10] ? this.files[10].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-files-o"></i> ({{ this.files[10] ? this.files[10].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <file-table :files="sectionFiles(10)" />
                    </b-card-body>
                </b-tab>
                <b-tab v-if="!is_subcontractor" no-body>
                    <template slot='title'>
                        <span class="d-sm-block d-none">
                            <i class="fa fa-sitemap"></i> Status History  ({{ this.statusHistoryBySection[10] ? this.statusHistoryBySection[10].length : 0 }})
                        </span>
                        <span class="d-sm-none d-block">
                            <i class="fa fa-sitemap"></i>  ({{ this.statusHistoryBySection[10] ? this.statusHistoryBySection[10].length : 0 }})
                        </span>
                    </template>
                    <b-card-body>
                        <status-history :histories="filteredOrderedHistory(10)" />
                    </b-card-body>
                </b-tab>
            </b-tabs>

            <!-- Additional Remarks -->
            <div class="row mb-4" style="margin-top: 70px">
                <div class="col-sm-8 col-xs-12 mb-sm-0 mb-1">
                    <h5 class="d-inline-block mb-0">Additional Remarks</h5>
                </div>
            </div>
            <b-card class="mt-0 mb-3">
                <div class="mb-1">
                    <div>
                        {{ subcontractor.additional_notes ? subcontractor.additional_notes : '--' }}
                    </div>
                </div>
            </b-card>
        </div>
        <sub-status-modal @statusChanged="statusChanged" ref="subStatusModal" :subcontractorId="subcontractor.subcontractor_id" />
        <sub-section-status-modal @sectionStatusChanged="statusChanged" ref="subSectionStatusModal" :subcontractorId="subcontractor.subcontractor_id" />
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                curTab: 'comments',
                userTimezone: this.$store.state.user.timezone,
                loading: true,
                showApprovedEditModal: false,
                showStatusCommentEditModal: false,
                updatingApproved: false,
                updatingStatusComment: false,
                subcontractor_id: this.$route.params.id,
                subcontractor: {},
                columns: ['sub_approval_id', 'client_name', 'approval_status_name', 'approval_created_at'],
                trades: [],
                areas: [],
                sub_registrations: [],
                files: [],
                fieldTrainings: [],
                testings: [],
                users: [],
                statusHistory: [],
                errors: {},
                current_status_section: null,
                approvals_out_of_date: false,
                is_subcontractor: this.$store.state.user.subcontractor_id,
                mostRecentStatusComment: null,
                totalComments: 0,
                totalClientApprovals: 0,
                totalHistory: 0,
                sectionComments: {
                    1: 0,
                    2: 0,
                    3: 0,
                    4: 0,
                    5: 0,
                    6: 0,
                    7: 0,
                    8: 0,
                    9: 0,
                    10: 0,
                },

                file_columns: ['file_id', 'file_name', 'section_number', 'user_id', 'created_at'],
                file_options: {
                    headings: {
                        file_id: 'Actions',
                        file_name: 'File Name',
                        section_number: 'Section',
                        user_id: 'Uploader',
                        created_at: 'Uploaded Date',
                    },
                    perPageValues: [],
                    sortable: ['file_name', 'section_number'],
                    columnsDropdown: false,
                    uniqueKey: 'file_id',
                },

                settingsTabs: {
                    comments: 'Comments',
                    files: 'Files',
                    approvals: 'Client Approvals',
                    status_history: 'Status History',
                    history: 'History',
                    osha: 'OSHA Data',
                },

                sub_settings: {},
            }
        },

        computed: {

            subcontractorAge(){
                //Make sure we have a valid date
                if(!this.subcontractor.business_start_date)
                {
                    return '';
                }

                //Now
                var now = moment();
                var start = moment(this.subcontractor.business_start_date);

                //Send it
                return parseFloat(now.diff(start, 'days') / 365).toFixed(2);
            },

            bondingAge(){
                //Make sure we have a valid date
                if(!this.subcontractor.bonding_start_date)
                {
                    return '';
                }

                //Now
                var now = moment();
                var start = moment(this.subcontractor.bonding_start_date);

                //Send it
                return parseFloat(now.diff(start, 'days') / 365).toFixed(2);
            },

            sectionStatuses() {
                return this.statusHistory.filter(e => e.is_current == 1);
            },

            files_array() {
                // This doesn't work in IE...
                // return Object.values(this.files).flat();

                let return_files = [];

                for (let i in this.files)
                {
                    return_files = return_files.concat(this.files[i]);
                }

                return return_files;
            },

            approvalsNeedRegenerating(){
                //Check the data
                if(!this.subcontractor.approval_data_changed_at ||
                    (this.subcontractor.status_name != 'Approved' && this.subcontractor.status_name != 'In Review' && this.subcontractor.status_name != 'Conditionally Approved'))
                {
                    return false;
                }

                //Send it.
                return true;
            },

            tabButtonTitle(){
                //Send it
                var icon = '<i class="fa fa-bars"></i> ';

                //Switch
                switch(this.curTab)
                {
                    case 'comments':
                        //Append Count
                        icon = '<i class="fa fa-comments"></i>';
                        break;

                    case 'files':
                        //Append Count
                        icon = '<i class="fa fa-files-o"></i>';
                        break;

                    case 'approvals':
                        //Append Count
                        icon = '<i class="fa fa-address-book-o"></i>';
                        break;

                    case 'status_history':
                        //Append Count
                        icon = '<i class="fa fa-sitemap"></i>';
                        break;

                    case 'history':
                        //Append Count
                        icon = '<i class="fa fa-clock-o"></i>';
                        break;
                }

                //Send it
                return icon + ' ' + this.settingsTabs[this.curTab];
            },

            statusHistoryBySection(){
                //Setup
                var history = {};

                //Loop and Build
                for (var i = this.statusHistory.length - 1; i >= 0; i--)
                {
                    //Check if Not Setup
                    if(history[this.statusHistory[i].section_number] === undefined)
                    {
                        history[this.statusHistory[i].section_number] = [];
                    }

                    //Push
                    history[this.statusHistory[i].section_number].push(this.statusHistory[i]);
                }

                //Send it
                return history;
            },

            publicUrl(){
                //Check for a KEY
                if(!this.subcontractor.sub_key)
                {
                    return '';
                }

                //Return it
                return this.$root.appUrl + '/subcontractors/access/' + this.subcontractor.sub_key + '/view';
            },
        },

        methods: {

            doApprovalsNeedRecalculating(metric){
                //Check the data
                if(!this.approvalsNeedRegenerating)
                {
                    //Make sure it's false
                    this.approvals_out_of_date = false;

                    //Stop here
                    return;
                }

                //Create the time the metric was calculated
                var metricTime = moment(metric.approval_created_at);
                var deltaTime = moment(this.subcontractor.approval_data_changed_at);

                //Check if the time the data was changed is GREATER than the most recent approval metric
                if(deltaTime.isSameOrAfter(metricTime))
                {
                    //Display the indicator
                    this.approvals_out_of_date = true;
                }
            },

            subcontractorPartsUpdated: function(data){
                //Update the cost
                this.subcontractor.cost = data.subcontractor_cost;

                //Redraw the table
                this.$refs.subcontractorParts.refreshData();
            },

            getSubcontractor: function() {
                //Get the data
                this.$http
                    .get(`subcontractors/qualification/view${this.subcontractor_id ? '/'+this.subcontractor_id : ''}`)
                    .then(response => {
                        //Set all the data
                        this.subcontractor = response.data.subcontractor;
                        this.trades = response.data.trades;
                        this.areas = response.data.areas;
                        this.sub_registrations = response.data.sub_registrations;
                        this.files = response.data.files;
                        this.fieldTrainings = response.data.fieldTrainings;
                        this.testings = response.data.testings;
                        this.users = response.data.users;
                        this.statusHistory = response.data.statusHistory;
                        this.mostRecentStatusComment = response.data.mostRecentStatusComment;
                        this.custom_field_sections = response.data.sections;

                        //Push the Settings
                        if(response.data.sub_settings)
                        {
                            //Set it
                            this.sub_settings = response.data.sub_settings;
                        }

                        //Set Designations
                        this.$store.commit('setBids', response.data.bids);
                        this.$store.commit('setCitations', response.data.citations);
                        this.$store.commit('setDesignations', response.data.designations);
                        this.$store.commit('setLicenses', response.data.licenses);
                        this.$store.commit('setSafetyYears', response.data.years);
                        this.$store.commit('setReferences', response.data.references);

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            approvalAction(){
                //Get the action
                this.$refs.subStatusModal.setModel({
                    status_id: this.subcontractor.status_id,
                    valid_until: this.subcontractor.valid_until,
                    comment: ''
                });
                this.$refs.subStatusModal.showModal();
            },

            approvalActionSection(section_number){
                let section_status = this.sectionStatus(section_number);
                var status_id = '';
                if (section_status)
                {
                    status_id = section_status.status_id;
                }

                //Get the action
                this.$refs.subSectionStatusModal.setSection(section_number);
                this.$refs.subSectionStatusModal.setModel({
                    status_id: status_id,
                    comment: ''
                });
                this.current_status_section = section_number;
                this.$refs.subSectionStatusModal.showModal();
            },

            editApprovedUntil(){
                //Show the modal
                this.showApprovedEditModal = true;

                //Now what?
            },

            updateApprovedUntil(bvEvt) {
               //Stops the modal from closing
               bvEvt.preventDefault();

               //Helper
               this.updatingApproved = true;

               //Send it
               this.$http
               .post('subcontractors/valid-until/' + this.subcontractor.subcontractor_id, {'valid_until': this.subcontractor.valid_until})
               .then(response => {
                   //Alert the user?
                   this.$toastr.success('Approved Until Updated');

                   //Show the modal
                   this.showApprovedEditModal = false;

               })
               .catch(error => {
                   //Check for error
                   if(error.response.status === 422)
                   {
                       //Display validation errors
                       this.errors = error.response.data
                   }
               })
               .then(response => {
                   //SHow loading
                   this.updatingApproved = false;
               });
            },

            editStatusComment(){
                //Show the modal
                this.showStatusCommentEditModal = true;

                //Now what?
            },

            updateStatusComment(bvEvt) {
               //Stops the modal from closing
               bvEvt.preventDefault();

               //Helper
               this.updatingStatusComment = true;

               //setup
               var payload = {'comment_details': this.mostRecentStatusComment.comment_details};

               //Send it
               this.$http
               .post('subcontractors/recent-status-comment/' + this.subcontractor.subcontractor_id + '/' + this.mostRecentStatusComment.comment_id, payload)
               .then(response => {
                   //Alert the user?
                   this.$toastr.success('Status Comment Updated');

                   //Show the modal
                   this.showStatusCommentEditModal = false;

               })
               .catch(error => {
                   //Check for error
                   if(error.response.status === 422)
                   {
                       //Display validation errors
                       this.errors = error.response.data
                   }
               })
               .then(response => {
                   //SHow loading
                   this.updatingStatusComment = false;
               });
            },

            readDate(date) {
                //Check for null
                if(!date)
                {
                    return null;
                }

                //Send it
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            },

            writeDate(date) {
                //Check for null
                if(!date || date == '')
                {
                    return null;
                }

                //Send it
                return moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
            },

            filteredOrderedHistory(section_number = null) {
                //Build Section History
                var section_history = this.statusHistory.slice().filter(e => {
                    //Check Section#
                    return e.section_number == section_number;
                });

                //Sort the Histoy
                section_history.sort(function(a,b){
                  // Turn your strings into dates, and then subtract them
                  // to get a value that is either negative, positive, or zero.
                  return new Date(a.created_at) - new Date(b.created_at);
                });

                //Send it
                return section_history;
            },

            sectionStatus(section_number) {
                let statuses = this.sectionStatuses.filter(e => {
                    return e.section_number == section_number;
                })

                if (statuses.length == 0)
                    return {'status_color': null, 'status_name': null}

                else return statuses[0];
            },

            sectionFiles(section_number) {
                return this.files[section_number];
            },

            statusChanged(data) {
                let did_update_multiple = data.did_update_multiple;
                let overall_status = data.status;

                if (this.current_status_section === null || did_update_multiple)
                {
                    this.subcontractor.status_id = overall_status.status_id;
                    this.subcontractor.status_color = overall_status.status_color;
                    this.subcontractor.status_name = overall_status.status_name;
                    this.subcontractor.status_name = overall_status.status_name;
                }
                if (this.current_status_section > 0)
                {
                    let update_statuses = this.sectionStatuses.filter(e => {
                        return e.section_number == this.current_status_section;
                    })

                    update_statuses.forEach(status => {
                        status.is_current = 0;
                    });

                    this.$refs['commentList'+this.current_status_section].getComments();
                }

                this.statusHistory = this.statusHistory.concat(data.histories);

                this.$refs.commentList.getComments();
                this.current_status_section = null;

                //Check for valid until
                if(typeof data.valid_until !== undefined)
                {
                    this.subcontractor.valid_until = data.valid_until;
                }
            },

            settingIsOn(section_num, setting_key){
                //Check if setting is turned on
                if(this.sub_settings[section_num][setting_key] !== undefined && this.sub_settings[section_num][setting_key] === 1)
                {
                    return true;
                }

                //Defaul
                return false;
            },
        },
        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        }
    }
</script>

<style>
    .no-form-group-margin .form-group {
        margin-bottom: 0;
    }
</style>
